'use strict'

import mapObj from '../map-obj'
import _ from 'lodash'

export default function(obj, options) {
  options = Object.assign({ deep: true, exclude: [] }, options)

  return mapObj(obj, function (key, val) {
    return [
      matches(options.exclude, key) ? key : _.snakeCase(key),
      val
    ]
  }, options)
}

function matches (patterns, value) {
  return patterns.some(function (pattern) {
    return typeof pattern === 'string'
      ? pattern === value
      : pattern.test(value)
  })
}
